/*
 * @Description:
 * @Date: 2020-11-14 14:13:08
 * @LastEditors: jml
 * @LastEditTime: 2020-12-03 21:00:36
 */
/**
 *
 * @param {
 *  deg 角度
 *  a 长轴
 *  b 短轴
 *  cx 圆心横坐标
 *  cy 圆心纵坐标
 * } param0
 */
export const getXY = ({ deg = 0, a = 0, b = 0, cx = 0, cy = 0 }) => {
  const _deg = deg > 360 ? deg - 360 : deg;
  if (!a || !b) {
    console.warn('请传入a=>长轴、b=>短轴');
    return [0, 0];
  }
  const tanDeg =
    Math.sin((Math.PI * _deg) / 180) / Math.cos((Math.PI * _deg) / 180);
  const powX =
    (Math.pow(a, 2) * Math.pow(b, 2)) /
    (Math.pow(tanDeg, 2) * Math.pow(a, 2) + Math.pow(b, 2));
  const x = Math.sqrt(powX);
  const y = tanDeg * x;
  let arr = [
    _deg > 90 && _deg <= 270 ? -x : x,
    _deg > 90 && _deg <= 270 ? -y : y
  ];
  if (_deg == 90) {
    arr = [0, y];
  }
  if (_deg == 180) {
    arr = [-x, 0];
  }
  if (_deg == 270) {
    arr = [0, -y];
  }
  if (_deg == 360) {
    arr = [x, 0];
  }
  arr[0] += cx;
  arr[1] += cy;
  return arr;
};

/**
 *
 * @param {
 *
 * leftTopPoint 左上点坐标
 * leftBottomPoint 左下点坐标
 * rightTopPoint 右上点坐标
 * rightBottomPoint 右下点坐标
 * height 3D图形高度，为0则是平面图
 * isCircle 是否为曲面
 * axis  曲面长轴与短轴，相等时则为圆形
 * axis2  小曲面长轴与短轴，相等时则为圆形
 * deg 角度
 * pyDeg 平移线的角度
 * pyDis 间隙
 * allMoveX 整体沿x轴移动距离
 * allMoveY 整体沿y轴移动距离
 * isAntiClockwise 逆时针绘制
 * } param0
 */
export const get3dSurfacePath = ({
  leftTopPoint = [0, 0],
  leftBottomPoint = [0, 0],
  rightTopPoint = [0, 0],
  rightBottomPoint = [0, 0],
  height = 0,
  isCircle = false,
  axis = [0, 0],
  axis2 = [0, 0],
  deg = 0,
  pyDeg = 0,
  pyDis = 0,
  allMoveY = 0,
  allMoveX = 0,
  startDeg = 0,
  endDeg = 0,
  xMoveDis = 0,
  yMoveDis = 0,
  isAntiClockwise = false
}) => {
  const [_axisX, _axisY] = axis;
  const [_axisX2, _axisY2] = axis2;
  const _isCircle = isCircle;
  const _deg = Math.abs(deg);
  const _height = height;
  const _d180 = _deg > 180;
  const [_pyDisX, _pyDisY] = [
    pyDis * Math.cos((Math.PI * pyDeg) / 180),
    pyDis * Math.sin((Math.PI * pyDeg) / 180)
  ];
  const _xMoveDis = xMoveDis;
  const _yMoveDis = yMoveDis;
  const _allMoveX = allMoveX;
  const _allMoveY = allMoveY;
  /**
   *
   * @param {目标点} p2
   * @param {使用小坐标轴} useAxis2
   * @param {画圆} drawCircle
   * @param {线条的index} lineIndex
   */
  const drawLine = (p2, useAxis2, drawCircle, lineIndex) => {
    const [p2x, p2y] = p2;
    if (_isCircle && drawCircle) {
      return `A${useAxis2 ? _axisX2 : _axisX} ${
        useAxis2 ? _axisY2 : _axisY
      } 0 ${_d180 ? 1 : 0} ${
        isAntiClockwise ? (lineIndex == 2 ? 1 : 0) : lineIndex == 2 ? 0 : 1
      } ${p2x} ${p2y}`;
    } else {
      return `L${p2x} ${p2y}`;
    }
  };
  /**
   *
   * @param {左上点} p1
   * @param {右上点} p2
   * @param {右下点} p3
   * @param {左下点} p4
   */
  const drawSurface = (
    p1,
    p2,
    p3,
    p4,
    { useAxis2Line = [0, 0, 0, 0], mayDrawCircle = [1, 0, 1, 0] }
  ) => {
    const [p1X, p1Y] = p1;
    if (_deg == 360) {
      const pArr = [
        [p1X + _axisX, p1Y - _axisY],
        [p1X + _axisX2, p1Y - _axisY],
        [p1X - _axisX2, p1Y - _axisY],
        [p1X + _axisX, p1Y - _axisY]
      ];
      const pArr2 = [
        [p1X - _axisX, p1Y - _axisY],
        [p1X - _axisX2, p1Y - _axisY],
        [p1X + _axisX2, p1Y - _axisY],
        [p1X - _axisX, p1Y - _axisY]
      ];
      const [
        line1,
        _line1,
        line2,
        _line2,
        line3,
        _line3,
        line4,
        _line4
      ] = useAxis2Line.reduce((pre, cur, index) => {
        pre.push(
          drawLine(pArr[index], cur == 1, mayDrawCircle[index] == 1, index),
          drawLine(pArr2[index], cur == 1, mayDrawCircle[index] == 1, index)
        );
        return pre;
      }, []);
      return `M${p1X - _axisX} ${p1Y -
        _axisY} ${line1} ${line2} ${line3} ${line4} M${p1X + _axisX} ${p1Y -
        _axisY} ${_line1} ${_line2} ${_line3} ${_line4} z`;
    } else {
      const pArr = [p2, p3, p4, p1];
      const [line1, line2, line3, line4] = useAxis2Line.reduce(
        (pre, cur, index) => {
          pre.push(
            drawLine(pArr[index], cur == 1, mayDrawCircle[index] == 1, index)
          );
          return pre;
        },
        []
      );
      return `M${p1X} ${p1Y} ${line1} ${line2} ${line3} ${line4} z`;
    }
  };
  const pointAddHeight = p => {
    const [x, y, z = y - _height] = p;
    return [x, z];
  };
  const pointDealDis = p => {
    const [
      x,
      y,
      _x = x + _pyDisX - _allMoveX,
      _y = y + _pyDisY - _allMoveY
    ] = p;
    return [_x, _y];
  };
  const pointDealDis2 = p => {
    const [x, y, _x = x + _xMoveDis, _y = y + _yMoveDis] = p;
    return [_x, _y];
  };
  let leftTopPointIsAddHeight = pointAddHeight(leftTopPoint);
  let rightTopPointIsAddHeight = pointAddHeight(rightTopPoint);
  let rightBottomPointIsAddHeight = pointAddHeight(rightBottomPoint);
  let leftBottomPointIsAddHeight = pointAddHeight(leftBottomPoint);
  if (pyDis) {
    leftTopPoint = pointDealDis(leftTopPoint);
    leftBottomPoint = pointDealDis(leftBottomPoint);
    rightTopPoint = pointDealDis(rightTopPoint);
    rightBottomPoint = pointDealDis(rightBottomPoint);
    leftTopPointIsAddHeight = pointDealDis(leftTopPointIsAddHeight);
    rightTopPointIsAddHeight = pointDealDis(rightTopPointIsAddHeight);
    rightBottomPointIsAddHeight = pointDealDis(rightBottomPointIsAddHeight);
    leftBottomPointIsAddHeight = pointDealDis(leftBottomPointIsAddHeight);
  }
  if (_xMoveDis || _yMoveDis) {
    leftTopPointIsAddHeight = pointDealDis2(leftTopPointIsAddHeight);
    rightTopPointIsAddHeight = pointDealDis2(rightTopPointIsAddHeight);
    rightBottomPointIsAddHeight = pointDealDis2(rightBottomPointIsAddHeight);
    leftBottomPointIsAddHeight = pointDealDis2(leftBottomPointIsAddHeight);
  }

  const _startDeg = startDeg > 360 ? startDeg - 360 : startDeg;
  const _endDeg = endDeg > 360 ? endDeg - 360 : endDeg;
  let returnArr = ['bottom', 'left', 'right', 'front', 'back', 'top'];
  if (_startDeg >= 0 && _endDeg <= 90) {
    returnArr = ['bottom', 'front', 'left', 'right', 'back', 'top'];
  }
  if (_startDeg >= 180) {
    returnArr = ['bottom', 'back', 'left', 'right', 'front', 'top'];
  }
  if (_deg == 360) {
    returnArr = ['bottom', 'left', 'right', 'top'];
  }
  if (!_isCircle) {
    returnArr = ['bottom', 'back', 'left', 'right', 'front', 'top'];
  }
  const surfacesObj = {
    // 两个特殊面，后期优化
    special: {},
    bottom: drawSurface(
      leftTopPoint,
      rightTopPoint,
      rightBottomPoint,
      leftBottomPoint,
      {
        useAxis2Line: [0, 0, 1, 0]
      }
    ),
    left: drawSurface(
      leftTopPoint,
      leftBottomPoint,
      leftBottomPointIsAddHeight,
      leftTopPointIsAddHeight,
      { mayDrawCircle: [0, 0, 0, 0] }
    ),
    right: drawSurface(
      rightBottomPoint,
      rightTopPoint,
      rightTopPointIsAddHeight,
      rightBottomPointIsAddHeight,
      { mayDrawCircle: [0, 0, 0, 0] }
    ),
    front: drawSurface(
      leftBottomPoint,
      rightBottomPoint,
      rightBottomPointIsAddHeight,
      leftBottomPointIsAddHeight,
      {
        useAxis2Line: [1, 0, 1, 0]
      }
    ),
    back: drawSurface(
      leftTopPoint,
      rightTopPoint,
      rightTopPointIsAddHeight,
      leftTopPointIsAddHeight,
      {}
    ),
    top: drawSurface(
      leftTopPointIsAddHeight,
      rightTopPointIsAddHeight,
      rightBottomPointIsAddHeight,
      leftBottomPointIsAddHeight,
      {
        useAxis2Line: [0, 0, 1, 0]
      }
    )
  };
  return returnArr.reduce(
    (pre, cur) => {
      pre[cur] = surfacesObj[cur];
      return pre;
    },
    {
      leftTopPoint,
      rightTopPoint,
      rightBottomPoint,
      leftBottomPoint,
      leftTopPointIsAddHeight,
      rightTopPointIsAddHeight,
      rightBottomPointIsAddHeight,
      leftBottomPointIsAddHeight
    }
  );
};

export const getTextPoint = ({
  point = [0, 0],
  height = 0,
  pyDeg = 0,
  pyDis = 0,
  allMoveY = 0,
  allMoveX = 0
}) => {
  const [_pyDisX, _pyDisY] = [
    pyDis * Math.cos((Math.PI * pyDeg) / 180),
    pyDis * Math.sin((Math.PI * pyDeg) / 180)
  ];
  const [a, b] = [4, 2];
  const [
    _x,
    _y,
    x = _x + _pyDisX - allMoveX - a,
    y = _y + _pyDisY - allMoveY - height - b
  ] = point;
  return {
    path: `M${x} ${y} A${a} ${b} 0 0 0 ${x +
      a * 2} ${y} A${a} ${b} 0 0 0 ${x} ${y}`,
    o: [x + a, y]
  };
};

export const dealSurfaces = surfaces => {
  return Object.entries(surfaces).reduce(
    (pre, cur) => {
      if (Array.isArray(cur[1])) {
        pre.surfacesPoint[cur[0]] = cur[1];
      } else {
        pre.surfaces[cur[0]] = cur[1];
      }
      return pre;
    },
    {
      surfaces: {},
      surfacesPoint: {}
    }
  );
};

/**
 *
 * @param {
 *  data 渲染饼图数组使用的
 *  axis  曲面长轴与短轴，相等时则为圆形
 *  miniAxis  小曲面长轴与短轴，相等时则为圆形
 *  pyDis 间距
 *  height 饼图z方向的高度，为0时则为平面图
 *  heightDis 高度差
 *  gapDeg 空隙角度
 * } param0
 */
export const getPie = ({
  data = [],
  axis = [0, 0],
  miniAxis = [0, 0],
  pyDis = 0,
  height = 0,
  heightDis = 0,
  gapDeg = 0,
  baseDeg = 360,
  finalDataCount = 0,
  sDeg = 90,
  xMoveDis = 0,
  yMoveDis = 0,
  isAntiClockwise = false
}) => {
  if (!Array.isArray(data)) {
    console.warn('data请传入数组');
    return [];
  }
  const getNumber = param => {
    const paramType = Object.prototype.toString.apply(param);
    if (['[object Object]', '[object Number]'].includes(paramType)) {
      if (paramType === '[object Number]') {
        return param;
      } else {
        if ('value' in param) {
          return parseInt(param['value']) || 0;
        } else {
          console.warn('data中对象含有value属性，并且为数字');
          return 0;
        }
      }
    } else {
      console.warn('data数组需为数字数组');
      return 0;
    }
  };
  const _finalDataCount =
    finalDataCount ||
    data.reduce((pre, cur) => {
      pre += getNumber(cur);
      return pre;
    }, 0);
  const _startDeg = sDeg;
  let startDeg = _startDeg;
  const [a, b] = axis;
  const [a1, b1] = miniAxis;
  const _height = height;
  const _pyDis = pyDis;
  const _heightDis = heightDis;
  const _gapDeg = data.length > 2 ? gapDeg : 0;
  const _baseDeg = baseDeg - data.length * _gapDeg;
  const dealObj = data.reduce(
    (pre, cur, index) => {
      let endDeg =
        startDeg +
        Math.min((_baseDeg * getNumber(cur)) / _finalDataCount, _baseDeg) -
        _gapDeg;
      if (isAntiClockwise) {
        endDeg = endDeg - (endDeg - sDeg) * 2;
      }
      let cIndex = 1;
      if (endDeg > 270 && endDeg <= 360) {
        cIndex = 0;
      }
      if (
        ((endDeg > 360 && endDeg <= 450) ||
          (startDeg > 360 && startDeg <= 450)) &&
        endDeg - startDeg <= 90
      ) {
        cIndex = 2;
      }
      const miniAxisAllIs0 = miniAxis.every(i => i === 0);
      const surfaces = get3dSurfacePath({
        leftTopPoint: getXY({
          deg: startDeg,
          a,
          b,
          cx: a,
          cy: b
        }),
        rightTopPoint: getXY({ deg: endDeg, a, b, cx: a, cy: b }),
        rightBottomPoint: miniAxisAllIs0
          ? [a, b]
          : getXY({
              deg: endDeg,
              a: a1,
              b: b1,
              cx: a,
              cy: b
            }),
        leftBottomPoint: miniAxisAllIs0
          ? [a, b]
          : getXY({
              deg: startDeg,
              a: a1,
              b: b1,
              cx: a,
              cy: b
            }),
        xMoveDis,
        yMoveDis,
        isCircle: true,
        axis: [a, b],
        axis2: [a1, b1],
        height: index * _heightDis + _height,
        deg: endDeg - startDeg,
        pyDis: _pyDis,
        pyDeg: startDeg + (endDeg - startDeg) / 2,
        allMoveY: 0,
        startDeg,
        endDeg,
        isAntiClockwise
      });
      const point = getTextPoint({
        point: getXY({
          deg: startDeg + (endDeg - startDeg) / 2,
          a: a1 + (a - a1) / 2,
          b: b1 + (b - b1) / 2,
          cx: a,
          cy: b,
          baseDeg
        }),
        height: index * _heightDis + _height,
        deg: endDeg - startDeg,
        pyDis: _pyDis,
        pyDeg: startDeg + (endDeg - startDeg) / 2,
        allMoveY: 0
      });
      const dealSurfacesRes = dealSurfaces(surfaces);
      pre.arr[cIndex].push({
        surfaces: dealSurfacesRes.surfaces,
        surfacesPoint: dealSurfacesRes.surfacesPoint,
        point,
        info: cur,
        index: index
      });
      startDeg = endDeg + _gapDeg;
      return pre;
    },
    {
      arr: [[], [], []]
    }
  );
  const pathArr = [
    ...dealObj['arr'][0],
    ...dealObj['arr'][1].reverse(),
    ...dealObj['arr'][2]
  ];

  return pathArr;
};
